export default __webpack_public_path__ + "static/media/photo2.eb96f46d.jpg";